var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6254 14.1794L10.0604 15.7444C9.35716 16.4477 8.40333 16.8428 7.40877 16.8428C6.41421 16.8428 5.46038 16.4477 4.75712 15.7444C4.05386 15.0412 3.65877 14.0873 3.65877 13.0928C3.65877 12.0982 4.05386 11.1444 4.75712 10.4411L6.28762 8.91062",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40953 5.78579L10.94 4.25529C11.6433 3.55202 12.5971 3.15694 13.5917 3.15694C14.5862 3.15694 15.5401 3.55202 16.2433 4.25529C16.9466 4.95855 17.3417 5.91237 17.3417 6.90694C17.3417 7.9015 16.9466 8.85533 16.2433 9.55859L14.6783 11.1236",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlink);
export default __webpack_public_path__ + "static/media/unlink.da8cf392a2962ebffe891886db1c686d.svg";
export { ForwardRef as ReactComponent };